var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHomeIconGray(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.99149 19.8943V17.1342C8.99148 16.4322 9.56381 15.8617 10.2729 15.857H12.8704C13.5829 15.857 14.1605 16.4288 14.1605 17.1342V17.1342V19.9028C14.1603 20.4989 14.6408 20.986 15.2427 21H16.9744C18.7006 21 20.1 19.6146 20.1 17.9056V17.9056V10.0541C20.0908 9.38174 19.7719 8.75041 19.2342 8.33973L13.3119 3.61677C12.2744 2.79441 10.7996 2.79441 9.76208 3.61677L3.86582 8.3483C3.32603 8.75732 3.00665 9.3897 3 10.0626V17.9056C3 19.6146 4.39939 21 6.12562 21H7.85727C8.47412 21 8.97418 20.5049 8.97418 19.8943V19.8943",
    stroke: "#717171",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIconGray);
export default __webpack_public_path__ + "static/media/home-icon-gray.61f6fe535c1a16a32cb69be6696c3388.svg";
export { ForwardRef as ReactComponent };